export const IS_BASKET_MODAL = 'IS_BASKET_MODAL'
export const IS_LOGIN_MODAL = 'IS_LOGIN_MODAL'
export const FETCH_BASKET_FROM_LOCAL = 'FETCH_BASKET_FROM_LOCAL'
export const SAVE_TO_LOCAL = 'SAVE_TO_LOCAL'
export const DELETE_FROM_LOCAL = 'DELETE_FROM_LOCAL'
export const CLEAR_BASKET = 'CLEAR_BASKET'
